module.exports = __webpack_public_path__ + "media/img/advice/icon--woman-dcc84e0f7912a6dfd3245dee7df0c2c7.png";